import { useState } from 'react';
import { Group, Header, SimpleCell, Spinner, File } from '@vkontakte/vkui';
import { useQuery, useMutation } from '@tanstack/react-query';
import { api, apiUpload } from '../../api/client';
import { useImportJob } from '../../api/hooks';

export function AdminLicenses() {
  const [jobId, setJobId] = useState<string | null>(null);
  const { data, isLoading } = useQuery({
    queryKey: ['admin', 'licenses'],
    queryFn: () =>
      api<{ licenses: Array<Record<string, unknown>> }>(
        '/api/admin/licenses?page=1&limit=50',
      ),
  });
  const importMut = useMutation({
    mutationFn: (file: File) =>
      apiUpload<{ jobId: string }>('/api/admin/licenses/import', file),
    onSuccess: (r) => setJobId(r.jobId),
  });
  const job = useImportJob(jobId);

  return (
    <>
      <Group header={<Header size="s">Импорт лицензий</Header>}>
        <File accept=".csv" onChange={(e) => {
          const f = e.target.files?.[0];
          if (f) importMut.mutate(f);
        }}>
          Загрузить CSV
        </File>
        {job.data?.report && (
          <SimpleCell>
            +{job.data.report.added} / skip {job.data.report.skipped} / err{' '}
            {job.data.report.errors}
          </SimpleCell>
        )}
      </Group>
      <Group header={<Header size="s">Пул</Header>}>
        {isLoading ? (
          <Spinner />
        ) : (
          data?.licenses?.map((l) => (
            <SimpleCell key={l.id as number} subtitle={l.status as string}>
              {l.login as string}
            </SimpleCell>
          ))
        )}
      </Group>
    </>
  );
}
